<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogFormVisible"
    width="600px"
    @close="close"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="用户 ID" prop="code">
        <el-input v-model.trim="form.code" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="管理员" prop="code">
        <el-switch
          v-model="form.is_admin"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </el-form-item>

      <el-form-item label="用户积分" prop="points">
        <el-input v-model.trim="form.points" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="用户名称" prop="nickname">
        <el-input v-model.trim="form.nickname" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="上级用户" prop="nickname">
        <el-select
          ref="select"
          v-model="form.pid"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="`${item.nickname} （${
              item.code
                ? item.code + '/' + item.ydm_code + '/' + item.ydr_code
                : '-'
            }）`"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="邮费模版" prop="nickname">
        <el-select v-model="form.postage_express_type" placeholder="请选择">
          <el-option
            v-for="item in postage_express_List"
            :key="item.value"
            :label="item.lable"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="电话号码" prop="mobile">
        <el-input v-model.trim="form.mobile" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="add_time">
        <el-input
          v-model.trim="form.add_time"
          :disabled="true"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户头像" prop="pic">
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { memberUdate, memberDetail, memberListAll } from '@/api/xgcApi'
  import { getUploadUrl, baseURL_print } from '@/config'

  export default {
    name: 'UserManagementEdit',
    components: {},
    props: {
      userList: {
        type: Array,
        default: function () {
          return []
        },
      },
    },
    data() {
      return {
        row: {},
        form: {
          is_admin: 0,
          postage_express_type: null,
          pid: null,
        },
        dialogFormVisible: false,
        postage_express_List: [
          {
            lable: '圆通',
            value: 1,
          },
          {
            lable: '京东',
            value: 2,
          },
          {
            lable: '顺丰海运',
            value: 3,
          },
          {
            lable: '特殊模版',
            value: 4,
          },
        ],
        queryForm: {
          page: 1,
          limit: 20,
        },
        rules: {
          username: [
            {
              required: true,
              trigger: 'blur',
              message: '请输入用户名',
            },
          ],
          password: [
            {
              required: true,
              trigger: 'blur',
              message: '请输入密码',
            },
          ],
          email: [
            {
              required: true,
              trigger: 'blur',
              message: '请输入邮箱',
            },
          ],
          permissions: [
            {
              required: true,
              trigger: 'blur',
              message: '请选择权限',
            },
          ],
        },
        // userList: [],
        title: '',
        imageUrl: '',
        actionUrl: baseURL_print + 'index/index/file',
        options: [],
      }
    },

    mounted() {},
    methods: {
      getUserInfo() {
        var data = {
          page: 1,
          limit: 100,
        }
        memberListAll(data).then(({ data }) => {
          this.options = data
          memberDetail({ id: this.row.id }).then((res) => {
            this.form = res.data
            this.imageUrl = res.data.pic
            this.dialogFormVisible = true
            if (res.data.p_user) {
              const hasId = this.options.some(
                (item) => item.id == res.data.p_user.id
              )
              if (!hasId) {
                this.options.push(res.data.p_user)
              }
            }
          })
        })
      },
      remoteMethod(e) {
        this.page = 1
        this.limit = 20
        var data = {
          nickname: e,
          page: 1,
          limit: 100,
        }
        memberListAll(data).then(({ data }) => {
          this.options = data
        })
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw)
        this.form.pic = getUploadUrl + res
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 或 png 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isJPG && isLt2M
      },
      async showEdit(row) {
        this.title = '用户信息编辑'
        this.row = row
        this.getUserInfo()
        // const {
        //   data
        // } = await memberDetail({
        //   id: row.id
        // })
        // this.form = data
        // this.imageUrl = data.pic
        // this.form = Object.assign({}, row)
      },

      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            const { msg } = await memberUdate(this.form)
            this.$baseMessage(msg, 'success')
            this.$emit('fetch-data')
            this.close()
          } else {
            return false
          }
        })
      },
    },
  }
</script>
<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
